export enum TempleAnalyticsActionTypes {
    API_RESPONSE_SUCCESS = '@@templeAnalytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@templeAnalytics/API_RESPONSE_ERROR',

    GET_ADMIN_DASHBOARD = '@@templeAnalytics/GET_ADMIN_DASHBOARD',

    RESET = '@@templeAnalytics/RESET',
}